import { worldInchesNew } from "common/utils/nominalNumbers";

export const STAIR_CUT_HEIGHT = worldInchesNew(84);
export const MIN_ROOM_SQ_FT_FOR_INTERIOR_DIMENSIONS = 6;
